exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\n\n.progress-ring_progress-ring_2ah6I {\n    margin: 0.5rem;\n}\n\n.progress-ring_progress-ring-svg_2y_x6 {\n    fill: transparent;\n}\n\n.progress-ring_progress-ring_2ah6I .progress-ring_progress-ring-ring_2wHxN {\n    stroke: var(--looks-light-transparent);\n}\n\n.progress-ring_progress-ring_2ah6I .progress-ring_progress-ring-value_2c1U2 {\n    stroke: var(--looks-secondary);\n    stroke-linecap: round;\n}\n", ""]);

// exports
exports.locals = {
	"progress-ring": "progress-ring_progress-ring_2ah6I",
	"progressRing": "progress-ring_progress-ring_2ah6I",
	"progress-ring-svg": "progress-ring_progress-ring-svg_2y_x6",
	"progressRingSvg": "progress-ring_progress-ring-svg_2y_x6",
	"progress-ring-ring": "progress-ring_progress-ring-ring_2wHxN",
	"progressRingRing": "progress-ring_progress-ring-ring_2wHxN",
	"progress-ring-value": "progress-ring_progress-ring-value_2c1U2",
	"progressRingValue": "progress-ring_progress-ring-value_2c1U2"
};